export default __webpack_public_path__ + "static/media/prodslide1.0a44e2e1.jpg";